import React, { useState } from 'react';
import ReusableDiv from 'src/helper/ReusableDiv';
import { useAccountStore } from "../../../hooks/admin/account";
import useReduxState from 'src/hooks/useReduxState';
import System from 'src/helper/system';
import { useUserStore } from 'src/hooks/admin/user';
import { useAxiosIndicatorCheck } from "src/store/hook/useAxiosIndicatorCheck";
import { __remove, __set } from "src/store/axios_indicator";
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const UnsponsorUserAcct = (props) => {
    const { data, SetStatus } = props;
    const [{ }, { }, { update_unsponsor_acct_by_user }] = useAccountStore();
    const [{ }, { }, { update_unsponsor_user_acct }] = useUserStore();
    const [, setRefreshGrid] = useReduxState(false, 'setRefreshGrid');
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [__check] = useAxiosIndicatorCheck();

    const queryPrams = System.getParams()
    const onHide = () => {
        SetStatus(false)
    };

    const onSubmit = async () => {
        setIsSubmitting(true);
        if (data.base === 'userDetails') {
            let params = {
                userId: data.userId,
                accountDetails: data.list.map((acc) => {
                    return {
                        accountNumber: acc.AccountNumber,
                        speedboat: System.avUserInfoData.speedBoatAbbr,
                        salesOrg: acc.SalesOrg,
                    }
                })
            }
            __set("UN_SPONSOR_API_CALL");
            await update_unsponsor_user_acct(params)
                .then((data) => {
                    system_alert_indicator({
                        name: "adminconsole",
                        message: "User has been successfully <b>Unsponsored</b> from account(s).",
                        type: "success",
                        isDisplay: true,
                    });

                    setRefreshGrid(true);
                    onHide();
                    __remove("UN_SPONSOR_API_CALL");
                }).catch((err) => {
                    system_alert_indicator({
                        name: "adminconsole",
                        message: err.response.data.message || 'Something went wrong',
                        type: "danger",
                        isDisplayIcon: true,
                        isDisplay: false,
                    });
                    __remove("UN_SPONSOR_API_CALL");
                })
        } else {
            let params = {
                ...queryPrams,
                userId: data.list.map(user => user.UserId),
            }
            __set("UN_SPONSOR_API_CALL");
            await update_unsponsor_acct_by_user(params)
                .then((data) => {
                    system_alert_indicator({
                        name: "adminconsole",
                        message: "User(s) has been successfully <b>Unsponsored</b> from account.",
                        type: "success",
                        isDisplay: true,
                    });
                    setRefreshGrid(true);
                    onHide();
                    __remove("UN_SPONSOR_API_CALL");
                }).catch((err) => {
                    system_alert_indicator({
                        name: "adminconsole",
                        message: err.response.data.message || 'Something went wrong',
                        type: "danger",
                        isDisplayIcon: true,
                        isDisplay: false,
                    });
                    __remove("UN_SPONSOR_API_CALL");
                })
        }
    };

    return (
        <>
            <div className="avnet-modal modal-730 unsponsor-modal">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => { onHide() }}>×</button>

                    {data.base === 'userDetails' ? ReusableDiv.PopupTitle("Unsponsor from Account(s)") : ReusableDiv.PopupTitle("Unsponsor User(s) from Account")}
                    <div className="modal-body">
                        <p className="text-center"> <strong> {data.base === 'userDetails' ? 'You are about to unsponsor this User from the Account(s) listed below.' : 'You are about to unsponsor this User(s) listed below.'} </strong></p>

                        <table className="bs5 table table-bordered mt-4 mb-4">
                            <thead>
                                {data.base === 'userDetails' ?
                                    <tr>
                                        <th>ACCOUNT NUMBER  </th>
                                        <th>ACCOUNT NAME </th>
                                        <th>SALES ORG</th>
                                    </tr> :
                                    <tr>
                                        <th>EMAIL  </th>
                                        <th>FIRST NAME </th>
                                        <th>LAST NAME</th>
                                    </tr>}
                            </thead>
                            <tbody>
                                {data.base === 'userDetails' ?
                                    data?.list?.map((v, i) => (

                                        <tr key={i}>
                                            <td>{v?.AccountNumber} </td>
                                            <td>{v?.AccountName} </td>
                                            <td>{v?.SalesOrg} </td>
                                        </tr>
                                    )) :
                                    data.list.map((v, i) => (
                                        <tr key={i}>
                                            <td>{v?.Email} </td>
                                            <td>{v?.FirstName} </td>
                                            <td>{v?.LastName} </td>
                                        </tr>
                                    ))
                                }
                            </tbody>
                        </table>
                        {data.base === 'userDetails' ? <p className="text-center">
                            This action can not be reversed. Click “OK” to complete.
                            <br /><span style={{ color: 'red' }}>  Note: you will not be able to reverse this action. </span>
                        </p> :
                            <p className="text-center">
                                Click “OK” to permanently unsponsor User(s) from the Account.
                                <br /><span style={{ color: 'red' }}>  Note: you will not be able to reverse this action. </span>
                            </p>
                        }


                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <button type="button" className="bs5 btn btn-secondary minw140"
                            disabled={isSubmitting}
                            onClick={() => { onHide() }}>Cancel</button>
                        <button
                            type="button"
                            className="bs5 btn btn-primary minw140"
                            disabled={__check(["UN_SPONSOR_API_CALL"]).status}
                            onClick={() => {
                                __check(["UN_SPONSOR_API_CALL"]).status
                                    ? e.preventDefault()
                                    : onSubmit();
                            }}
                        >
                            {(__check("UN_SPONSOR_API_CALL").status) ? (
                                <i className="fa fa-spinner fa-spin" />
                            ) : (
                                "OK"
                            )}{" "}
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UnsponsorUserAcct;